var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAddSubtypeBold = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_cs_add_subtype copy") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_cs_add_subtype-copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4-Copy",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  stroke: "#354052",
  strokeWidth: 1.5,
  cx: 12,
  cy: 12,
  r: 8.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.75,11.25 L16,11.25 L16,12.75 L12.75,12.75 L12.75,16 L11.25,16 L11.25,12.75 L8,12.75 L8,11.25 L11.25,11.25 L11.25,8 L12.75,8 L12.75,11.25 Z",
  id: "Combined-Shape",
  fill: "#354052"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddSubtypeBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_add_subtype_bold.72b5fa0f316d7168cfe8739a5ffb2588.svg";